// extracted by mini-css-extract-plugin
module.exports = {"root":"voteItem_root__1EefJ","num_box":"voteItem_num_box__1xOku","file_box":"voteItem_file_box__1Cn3H","vote_btn":"voteItem_vote_btn__2sa6y"};